import { useState } from "react";
import { FiX } from "react-icons/fi";
import { AssetsListVisibility } from "@kagami/shared/assetsList";

import Button from "../ui/Button";
import { Input } from "../ui/shadcn/input";
import { Switch } from "../ui/shadcn/switch";
import {
  DEFAULT_ASSETS_LIST_VISIBILITY,
  MAX_ASSETS_LIST_NAME_LENGTH,
} from "@/components/AssetsList/constants";

export default function AssetsListSaveAsModal({
  onClose,
  initialName = "",
  initialVisibility = DEFAULT_ASSETS_LIST_VISIBILITY,
}) {
  const [name, setName] = useState(initialName);
  const [visibility, setVisibility] = useState(initialVisibility);

  const trimmedName = name.trim();
  const isNameValid = trimmedName.length > 0;
  const isPublic = visibility === AssetsListVisibility.Public;

  const handleVisibilityChange = (shouldBePublic) => {
    if (shouldBePublic) {
      setVisibility(AssetsListVisibility.Public);
      return;
    }
    setVisibility(AssetsListVisibility.Private);
  };

  const handleConfirm = () => {
    if (!isNameValid) return;
    onClose({ name: trimmedName, visibility });
  };

  const handleNameKeyDown = (event) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    handleConfirm();
  };

  return (
    <div
      id="AssetsListSaveAsModal"
      className="AssetsListSaveAsModal w-full max-w-[460px] rounded-md flex flex-col bg-background border">
      <div className="flex justify-between items-center py-2 px-4 border-b">
        <span className="text-lg font-bold">Save list as</span>
        <button
          id="AssetsListSaveAsModal__close"
          type="button"
          onClick={() => onClose(null)}
          className="shrink-0 p-1.5 rounded-md text-secondary-foreground/70 hover:text-foreground hover:bg-secondary/60 cursor-pointer"
          title="Close">
          <FiX className="w-5 h-5" />
        </button>
      </div>

      <div className="flex flex-col gap-4 p-4">
        <label className="flex flex-col gap-1">
          <span className="text-xs text-secondary-foreground/70">Name</span>
          <Input
            id="AssetsListSaveAsModal__name"
            type="text"
            autoFocus
            value={name}
            maxLength={MAX_ASSETS_LIST_NAME_LENGTH}
            placeholder="Name this list"
            onChange={(event) => setName(event.target.value)}
            onKeyDown={handleNameKeyDown}
          />
        </label>

        <div className="flex items-center justify-between">
          <span className="flex flex-col">
            <span className="text-xs font-medium">
              {isPublic ? "Public" : "Private"}
            </span>
            <span className="text-[11px] text-secondary-foreground/60">
              {isPublic
                ? "Anyone on this show can load it"
                : "Only you can load it"}
            </span>
          </span>
          <Switch
            id="AssetsListSaveAsModal__visibility"
            checked={isPublic}
            onCheckedChange={handleVisibilityChange}
          />
        </div>
      </div>

      <div className="flex justify-between p-2 border-t">
        <Button
          id="AssetsListSaveAsModal__cancel"
          type="danger-ghost"
          className="min-w-20"
          onClick={() => onClose(null)}>
          Cancel
        </Button>
        <Button
          id="AssetsListSaveAsModal__confirm"
          type="primary"
          className="min-w-20"
          disabled={!isNameValid}
          onClick={handleConfirm}>
          Save
        </Button>
      </div>
    </div>
  );
}
